__turbopack_context__.v({
  "body": "styles-module__1TETIa__body",
  "brick": "styles-module__1TETIa__brick",
  "cta": "styles-module__1TETIa__cta",
  "half": "styles-module__1TETIa__half",
  "halfLeft": "styles-module__1TETIa__halfLeft",
  "halfRight": "styles-module__1TETIa__halfRight",
  "inner": "styles-module__1TETIa__inner",
  "root": "styles-module__1TETIa__root",
  "title": "styles-module__1TETIa__title",
});
